import type { DashboardStatus } from './dashboardTypes';

export interface DashboardFilters {
  status: DashboardStatus | '';
  formCode: string;
  dueFrom: string;
  dueTo: string;
}

export const NO_FILTERS: DashboardFilters = { status: '', formCode: '', dueFrom: '', dueTo: '' };

export function filtersActive(f: DashboardFilters): boolean {
  return f.status !== '' || f.formCode !== '' || f.dueFrom !== '' || f.dueTo !== '';
}

export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
export const TAB_PANEL_ID = 'tpd-tabpanel';
export const tabId = (tab: string) => `tpd-tab-${tab}`;
